import { Component, createRef } from 'preact';
import { html } from '../../helpers/preact-html';
import EmblaCarousel from 'embla-carousel';

class MobileNavigationSelector extends Component {
  constructor() {
    super();
    this.refWrapper = createRef();
    this.refSlider = createRef();

    this.onScroll = this.onScroll.bind(this);
    this.onClickItem = this.onClickItem.bind(this);
    this.scrollRight = this.scrollRight.bind(this);
    this.scrollLeft = this.scrollLeft.bind(this);
  }

  componentDidMount() {
    this.embla = EmblaCarousel(this.refSlider.current, {
      containScroll: 'keepSnaps',
      align: 'start',
    });

    this.embla.on('scroll', this.onScroll);
    this.embla.on('resize', () => this.setState({}));
  }

  componentWillUnmount() {
    this.embla && this.embla.destroy();
  }

  onScroll() {
    const currentSlideId = this.embla.selectedScrollSnap();
    if (currentSlideId !== this.props.currentSlideId) {
      this.props.onSlideIdChange &&
        this.props.onSlideIdChange(this.props.navTree.items[currentSlideId].id);
    }
  }

  scrollRight() {
    const newSlideIndex = this.embla.selectedScrollSnap() + 1;
    this.props.onSlideIdChange(this.props.navTree.items[newSlideIndex].id);
  }

  scrollLeft() {
    const newSlideIndex = this.embla.selectedScrollSnap() - 1;
    this.props.onSlideIdChange(this.props.navTree.items[newSlideIndex].id);
  }

  onClickItem(slideId) {
    if (slideId !== this.props.currentSlideId) {
      this.props.onSlideIdChange &&
        this.props.onSlideIdChange(
          this.props.navTree.items.find(({ id }) => id === slideId).id,
        );
    }
  }

  render({ navTree, currentSlideId }) {
    const currentSlideIndex = navTree.items.findIndex(
      (menuItem) => menuItem.id === currentSlideId,
    );
    if (this.embla && this.embla.selectedScrollSnap() !== currentSlideIndex) {
      this.embla.scrollTo(currentSlideIndex);
    }

    const canScrollNext = this.embla && this.embla.canScrollNext();
    const canScrollPrev = this.embla && this.embla.canScrollPrev();

    return html`
      <div class="navigation-selector" ref=${this.refWrapper}>
        <div class="embla__viewport" ref=${this.refSlider}>
          <div class="embla__container">
            ${navTree.items.map(({ id, label }) => {
              const slideClasses = ['embla__slide'];
              if (id === currentSlideId) slideClasses.push('is-current');
              return html`
                <button
                  class="${slideClasses.join(' ')}"
                  onClick=${() => this.onClickItem(id)}
                >
                  <div class="embla__slide__inner">${label}</div>
                </button>
              `;
            })}
          </div>
        </div>
        ${canScrollPrev &&
        html`
          <button
            onClick=${this.scrollLeft}
            class="button button-icon-mediumicon navigation-selector-button-prev"
          >
            <i class="ri-arrow-left-s-line" aria-label="Pfeil nach links"></i>
          </button>
        `}
        ${canScrollNext &&
        html`
          <button
            onClick=${this.scrollRight}
            class="button button-icon-mediumicon navigation-selector-button-next"
          >
            <i class="ri-arrow-right-s-line" aria-label="Pfeil nach rechts"></i>
          </button>
        `}
      </div>
    `;
  }
}

export { MobileNavigationSelector };
